import React, { useState } from 'react';
import { Container, Row, Card, Col, Form, Button, Spinner } from 'react-bootstrap';
import { useEffect } from 'react';
import { ArrowBackIos, WidgetsOutlined } from '@material-ui/icons';
import ProviderRequestService from 'services/provider-request';
import FileUpload from 'components/FileUpload';
import { Link, useParams } from 'react-router-dom';
import ProviderDocuments from './ProviderDocuments';
import UnauthorizedAccess from 'components/Error/UnauthorizedAccess';
import ProviderResales from './ProviderResales';
import Swal from 'sweetalert2';
import Alert from 'helpers/alert';

export default function(){
  const [currentCompany] = useState(JSON.parse(localStorage.getItem('currentCompany')));

  const { id } = useParams();
  const [provider, setProvider] = useState({});
  const [imageLogo, setImageProfile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);

  const [documents, setDocuments] = useState([]);
  const [documentsRemove, setDocumentsRemove] = useState([]);
  const [listCompanySelected, setListCompanySelect] = useState([]);
  const [errorAccess, setErrorAccess] = useState(false);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    if (id) {
      ProviderRequestService.show(id, {
        params: {
          __company_id: currentCompany ? currentCompany.id : null
        }
      }).then(data => {
        setLogoPreview(
          data.data.url_image_logo
            ? data.data.url_image_logo
            : null
        );
        setProvider(data.data);
      }).catch(error => {
        if (error.response.status === 403 && error.response.data.message === "unauthorized access") {
          setErrorAccess(true);
        }
      });
      ProviderRequestService.getDocument(id).then(data => {
        setDocuments(data.data.map(a => {
          return {
            id: a.id,
            category_id: a.document_category_id,
            name: a.name,
            url_document: a.url_document,
            document_name: a.document_name,
          }
        }))
      });
      ProviderRequestService.getCompany(id).then(data => {
        setListCompanySelect(data.data.map(a => {
          return { id: a.company_id, label: a.label }
        }));
      });
    }
  }, [id])

  const handleSubmit = (e) => {
    setLoad(true);
    e.preventDefault();
    const formData = new FormData();
    let model = [
      { key: 'name', required: true },
    ];
    model.forEach((item) => {
      if (item.required) {
        if (
          provider[item.key] &&
          provider[item.key] !== '' &&
          provider[item.key] !== null &&
          provider[item.key] !== 0
        )
          formData.append(item.key, provider[item.key]);
      } else formData.append(item.key, provider[item.key] ? provider[item.key] : '');
    });

    let model_documents = [
      { key: 'id', required: false },
      { key: 'name', required: true },
      { key: 'category_id', required: true },
      { key: 'doc', required: true },
      { key: 'type', required: true },
    ];
    if (imageLogo) formData.append('file', imageLogo);

    documents.forEach((a, i) => {
      model_documents.forEach((k) => {
        if (k.required) {
          if (a[k.key])
            formData.append(`documents[${i}][${k.key}]`, a[k.key]);
          else
            return;
        } else {
          if (a[k.key])
            formData.append(`documents[${i}][${k.key}]`, a[k.key]);
        }
      })
    });

    documentsRemove.forEach((a, i) => {
      formData.append(`documents_remove[${i}]`, a);
    });

    listCompanySelected.forEach((a, i) => {
      formData.append(`companies[${i}][id]`, a.id);
      formData.append(`companies[${i}][label]`, a.label);
    });

    if (id) {
      formData.append("_method", "put");
      ProviderRequestService.update(id, formData).then(() => {
        let message = "Fornecedor atualizado com sucesso!";
        setLoad(false);
        Alert.success(message).then((result) => {
          if (result.dismiss === Swal.DismissReason.timer) {
            window.location.reload();
            setLoad(false);
          }
        });
      });
    } else {
      ProviderRequestService.store(formData).then((data) => { 
        let message = "Fornecedor criado com sucesso!";
        setLoad(false);
        Alert.success(message).then((result) => {
          if (result.dismiss === Swal.DismissReason.timer) {
            window.location.href = '/master-agent/provider/show/' + data.data.id 
            setLoad(false);
          }
        });
      });
    }
  };

  if (errorAccess) {
    return <UnauthorizedAccess />
  }

  return (
    <>
      <Container className="mb-5">
        <Row className="mt-4">
          <Link to="/master-agent/providers" className="link-back">
            <ArrowBackIos className="icon-title icon-back" />
            <h6 className="font-13 mt-3">Voltar</h6>
          </Link>
        </Row>
        <Row className="col-12 mt-4 row">
          <WidgetsOutlined className="icon-title" />
          <h5 className="title-dashboard">Fornecedor</h5>
        </Row>
        <Row>
          <Col className="col-12 d-flex justify-content-center my-3">
            <Card.Body className="shadow bg-white rounded pt-3">
              <Form noValidate className="" onSubmit={handleSubmit}>
                <Row className="">
                  <Col md="12">
                    <h6 className="title-dashboard">Informações</h6>
                  </Col>
                  <Col md="12">
                    <hr className="line"></hr>
                  </Col>
                </Row>
                <Form.Row>
                  <Form.Group as={Col} xs="12" md="6">
                    <Form.Label>Nome Fantasia</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      value={provider.name}
                      onChange={(e) =>
                        setProvider({ ...provider, name: e.target.value })
                      }
                    />
                  </Form.Group>
                </Form.Row>
                <Row className="mb-3 mt-4">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label>Selecione o logotipo da empresa:</Form.Label>
                      <FileUpload
                        file={imageLogo}
                        setFile={setImageProfile}
                        preview={logoPreview}
                        setPreview={setLogoPreview}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <ProviderDocuments
                  documents={documents}
                  setDocuments={setDocuments}
                  documentsRemove={documentsRemove}
                  setDocumentsRemove={setDocumentsRemove}
                  edit={true}
                />
                <ProviderResales
                  listCompanySelected={listCompanySelected}
                  setListCompanySelect={setListCompanySelect}
                />
                <Form.Row className="col-12 pr-0">
                  <Form.Group as={Col} xs="auto">
                    {load ? (
                      <Spinner animation="border" style={{ color: '#e05c17' }} />
                    ) : (
                        <Button block variant="primary" type="submit" disabled={false}>
                          Salvar
                        </Button>
                      )}
                  </Form.Group>
                </Form.Row>
              </Form>
            </Card.Body>
          </Col>
        </Row>
      </Container>
    </>
  );
}